import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Spinner from "../../../reusable/Spinner/Spinner";
import { injectIntl, FormattedMessage } from 'react-intl';
import {Button} from "../../../reusable/Form/Buttons";
import { toPairs, toLower } from 'lodash';

class AssignToCategory extends Component {
    static propTypes = {
        categories: PropTypes.object,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        onSave: PropTypes.func
    }

    static defaultProps = {
        categories: null,
        disabled: false,
        className: ""
    }

    constructor(props) {
        super(props);
        this.state = {
            selectedCategory: 'selectCategory',
            activeModal: null
        }

        this.handleChangeCategory = this.handleChangeCategory.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleSave() {
        this.props.onSave(this.state.selectedCategory);
    }

    handleChangeCategory(e) {
        if (e.target.value === "addNewCategory") {
            this.props.onSave("addNewCategory")
            this.setState({ selectedCategory: "selectCategory" })
        } else {
            this.setState({ selectedCategory: e.target.value });
        }
    }

    render() {
        let categoryOptions = []
        if (this.props.categories) {
            let sortedCategories = toPairs(this.props.categories).sort((a, b) => toLower(a[1]) < toLower(b[1]) ? -1 : 1)
            sortedCategories.forEach(category => {
                categoryOptions.push(
                    <option key={'category-option-' + category[0]} value={category[0]}>
                        {category[1]}
                    </option>
                );
            });
        }
        return <Spinner isLoading={this.props.categories === null} tiny>
            <span className={"review-companies-page__action-bar__group " + this.props.className}>
                <label>
                    <FormattedMessage id="General_CoreFunctionality_UIText_general.addToCategory" />:
                </label>
                <select disabled={this.props.disabled}
                        className="notranslate review-company-category-select qa-category-select"
                        id="review-company-category-select"
                        value={this.state.selectedCategory}
                        name="company-category"
                        onChange={this.handleChangeCategory}
                        defaultValue="selectCategory"
                        title={this.props.intl.formatMessage({id: 'General_CoreFunctionality_UIText_general.selectCategory'})}>
                    <option disabled value="selectCategory">
                        {this.props.intl.formatMessage({id: 'General_CoreFunctionality_UIText_general.selectCategory'})}
                    </option>
                    <option value="addNewCategory">
                        {this.props.intl.formatMessage({id: 'General_CoreFunctionality_UIText_general.addNewCategory'}) + '...'}
                    </option>
                    {categoryOptions}
                </select>
                <Button action={this.handleSave} disabled={this.props.disabled || this.state.selectedCategory === "selectCategory"}>
                    <FormattedMessage id="General_CoreFunctionality_UIText_general.save" />
                </Button>
            </span>
        </Spinner>
    }
}

export default injectIntl(AssignToCategory);


// WEBPACK FOOTER //
// ./src/scripts/pages/Entities/components/AssignToCategory.jsx